import { useContext } from 'react'

import { ParametrizationConfigToleranciaContext } from '@provider/Parametrization/ConfigToleranciaParamProvider'

import { IConfigToleranciaParamProvider } from '@base/@types/providers/Parametrization/ConfigParamTolerancia'
export default function useParametrizationConfigTolerancia(): IConfigToleranciaParamProvider {
  const context = useContext(ParametrizationConfigToleranciaContext)

  return context
}
